"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extractParams_1 = __importDefault(require("./extractParams"));
var makeQueryString_1 = __importDefault(require("./makeQueryString"));
var splitUrl_1 = __importDefault(require("./splitUrl"));
/**
 * Takes an `adjust` function that defines how to handle params from a URL's
 * querystring and returns the transformed URL.
 *
 * Ensures we remove the `?` if there are no query params in the adjusted URL.
 */
var adjustUrlParams = function (adjust, url) {
    var parts = splitUrl_1.default(url);
    var newParams = adjust(extractParams_1.default(url)) || {};
    var newUrl = parts.baseHref + "?" + makeQueryString_1.default(newParams);
    // Strip trailing `?` if there are no params
    return newUrl.replace(/\?$/, '');
};
exports.default = adjustUrlParams;
